import { useEffect, useState } from 'react';

interface Return {
  time: number;
  reset: () => void;
}

export default function useCountdown(seconds: number): Return {
  const [time, setTime] = useState(seconds);

  const reset = () => {
    setTime(seconds);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(time - 1);
    }, 1000);

    if (time <= 0 && timer) {
      clearInterval(timer);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [time, setTime]);

  return { time, reset };
}
